import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportOrdemComprasUseCase } from "../../../presentation/useCases/read/get_report_ordem_compras_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs, { Dayjs } from "dayjs";

/**
 * GetReportOrdemComprasUseCase
 */

export class GetReportOrdemComprasUseCase implements IGetReportOrdemComprasUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportOrdemCompras(
    requiredMimeType: ReportMimeType | null,
    idUsuario: number,
    ordemCompras: number[] | undefined,
    centroCustos: number[] | undefined,
    status: number,
    fornecedores: number[] | undefined,
    data: (Dayjs | null)[] | undefined,
  ): Promise<ReportData> {
    let normalizedStatus = 0;

    switch (status) {
      case 2:
        normalizedStatus = 1;
        break;

      case 3:
        normalizedStatus = 2;
        break;

      case 4:
        normalizedStatus = 3;
        break;
    }

    const response = await this.repository.getReportOrdemCompras(
      requiredMimeType,
      idUsuario,
      ordemCompras !== undefined && ordemCompras.length > 0 ? ordemCompras : null,
      centroCustos !== undefined && centroCustos.length > 0 ? centroCustos : null,
      normalizedStatus,
      fornecedores !== undefined && fornecedores.length > 0 ? fornecedores : null,
      data !== undefined && data.length > 0 && data[0] !== null ? data[0].toDate() : null,
      data !== undefined && data.length > 1 && data[1] !== null ? data[1].toDate() : null,
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `ordem_compras_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
